export default "__VITE_PUBLIC_ASSET__3afe7194__"